/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import "./ConfirmModal.scss";
import { OutlinedBtn, PrimaryBtn } from "../../buttons/Buttons";
import CloseIcon from "@mui/icons-material/Close";

/**
 *
 * Renders a modal with conten, cancel and confirm buttongs
 */
interface IProps {
  dialogContentText?: string;
  dialogTitle?: string;
  onConfirmClick?: () => void;
  open: boolean;
  onCancelClick: () => void;
  onCloseClick: () => void;
  primaryBtnText?: string;
}
const ConfirmDialog = (props: IProps) => {
  const [open, setOpen] = useState(props.open);

  return (
    <Dialog
      open={props.open}
      // onClose={()=>setCancelOpen(false)}
      sx={{ backdropFilter: "blur(3px)" }}
    >
      <DialogTitle className="dialogHeading" id="dialog-title">
        {props.dialogTitle}
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => setOpen(false)}
          aria-label="close"
          sx={{ marginLeft: "auto" }}
        >
          <CloseIcon
            onClick={() => props.onCloseClick && props.onCloseClick()}
            data-testid="closeIcon"
          />
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "#272727" }}>
        <DialogContentText
          sx={{ backgroundColor: "#272727" }}
          className="dialogInfo"
        >
          {props.dialogContentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#272727",
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <OutlinedBtn
          btnText="Cancel"
          onClick={() => props.onCancelClick && props.onCancelClick()}
        />
        <PrimaryBtn
          btnText={props.primaryBtnText ? props.primaryBtnText : "Create"}
          onClick={() => props.onConfirmClick && props.onConfirmClick()}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
